import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDashboardRoutingModule } from './user-dashboard-routing.module';
import { UserDashboardcardsModule } from './user-dashboardcards/user-dashboardcards.module';

@NgModule({
  imports: [
    CommonModule,
    UserDashboardRoutingModule,
    UserDashboardcardsModule,
  ],
  declarations: []
})
export class UserDashboardModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboard.module.ts